import { useCallback } from 'react'
import { getSessionType, redirectToLogin, sessionTypes } from '@fs/zion-session'
import { useOverlayContext } from '../../shared/providers/overlayContextProvider/OverlayContext'

/**
 * Returns a handler that opens the classic 4-step Attach to Tree flow, or — because attaching requires
 * a user session (FSS-14845) — redirects anonymous patrons to sign in, preserving the intent via an
 * `action=attach` param that SideSheet consumes on return.
 *
 * @returns {() => void}
 */
export default function useOpenAttachToTree() {
  const { openOverlay } = useOverlayContext()

  return useCallback(() => {
    if (getSessionType() !== sessionTypes.userSession) {
      const returnUrl = new URL(window.location.href)
      returnUrl.searchParams.set('action', 'attach')
      redirectToLogin(returnUrl.toString())
      return
    }

    openOverlay('mainInfosheet')
    openOverlay('attachToTreeOverlay')
  }, [openOverlay])
}
